import styled from "styled-components";
import Dialog from "@material-ui/core/Dialog/";
import globalColors from "../../../../../_metronic/_assets/sass/custom/globalColors.scss";

export const StyledDialog = styled(Dialog)`
  .MuiBackdrop-root {
    background-color: rgba(77, 76, 77, 0.5) !important;
  }

  .MuiPaper-root {
    max-width: 450px;
  }

  .MuiDialogTitle-root {
    padding-top: 24px;
    padding-bottom: 8px;

    .MuiTypography-root {
      text-align: center;
      font-family: "Open Sans";
      font-weight: 700;
      font-size: 20px;
      line-height: 150%;
      color: ${globalColors.primaryColor2};
    }
  }

  .MuiDialogContent-root {
    padding: 24px;

    #alert-dialog-description {
      font-family: "Open Sans";
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: ${globalColors.textColor2};
      margin: 0;
    }
  }

  .MuiDialogActions-root {
    justify-content: center;
    padding: 0;
    gap: 24px;
    margin: 8px 24px 24px;
  }
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 46px;
  width: 100%;
  max-width: 145px;
  margin: 0 !important;
  border-radius: 4px;
  padding: 0 15px;
  text-decoration: ${({ color }) => (color !== "primary" ? "underline" : "")};
  border: ${({ color }) =>
    color === "primary" ? globalColors.primaryColor2 : "transparent"};

  background: ${({ color }) =>
    color === "primary" ? globalColors.primaryColor2 : "transparent"};

  font-family: "Open Sans";
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${({ color }) =>
    color === "primary" ? globalColors.colorWhite : globalColors.primaryColor2};

  box-shadow: ${({ color }) =>
    color === "primary"
      ? "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)"
      : "none"};

  &:disabled {
    opacity: 0.8;
    cursor: not-allowed;
  }

  svg {
    margin-left: ${({ color }) => (color === "primary" ? "5px" : "0px")};
    margin-right: ${({ color }) => (color !== "primary" ? "5px" : "0px")};
  }
`;
